import { WorkflowCaseStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { useTranslation } from 'react-i18next'

import { type BadgeProps } from '@enechain/ecloud-designsystem'

import { Badge } from '~/components/common/Badge'

/**
 * WorkflowCase ステータスをバッジ表示プロパティ (i18n ラベルキー + 色) に変換する純粋関数。
 *
 * ステータスと色の対応:
 *   NOT_STARTED   → neutral (グレー)  = 未着手
 *   IN_PROGRESS   → info   (青)      = 進行中
 *   COMPLETE      → positive (緑)    = 完了
 *   DELETED       → negative (赤)    = 削除（不可逆、workflow-delete-transition design）
 */
export function workflowCaseStatusBadgeProps(status: WorkflowCaseStatus): {
  labelKey: string
  status: BadgeProps['status']
} {
  switch (status) {
    case WorkflowCaseStatus.NOT_STARTED:
      return {
        labelKey: 'page:workflowCases.status.notStarted',
        status: 'neutral',
      }
    case WorkflowCaseStatus.IN_PROGRESS:
      return {
        labelKey: 'page:workflowCases.status.inProgress',
        status: 'info',
      }
    case WorkflowCaseStatus.COMPLETE:
      return {
        labelKey: 'page:workflowCases.status.complete',
        status: 'positive',
      }
    case WorkflowCaseStatus.DELETED:
      return {
        labelKey: 'page:workflowCases.status.deleted',
        status: 'negative',
      }
    default:
      return {
        labelKey: 'page:workflowCases.status.notStarted',
        status: 'neutral',
      }
  }
}

/**
 * WorkflowCase ステータスバッジ共通コンポーネント。
 * i18n key `page:workflowCases.status.*` を使用する。
 * DemandForecastList / WorkflowCases/CaseTable の両方で使用。
 */
export const WorkflowCaseStatusBadge = ({
  status,
}: {
  status: WorkflowCaseStatus
}): React.ReactElement => {
  const { t } = useTranslation()
  const { labelKey, status: badgeStatus } = workflowCaseStatusBadgeProps(status)
  return <Badge status={badgeStatus}>{t(labelKey)}</Badge>
}
